<template>
  <q-route-tab
    to="/unreviewed"
    name="unreviewed"
    :label="label"
    exact
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import { status, matches } from '@/social/post/post';
import postRepository from '@/social/post/post-repository';
import eventBus from '@/messaging/event-bus';
import {
  PostSaved,
  PostEscalated,
  PostTrashed,
  PostRestored,
  PostMovedToTimeline,
} from '@/messaging/events';

interface Data {
  total: number,
  filters: PostFilters
}

export default defineComponent({
  data(): Data {
    return {
      total: -1,
      filters: {
        statuses: [status.UNREVIEWED],
        socialSiteIds: [],
        isTrashed: false,
        since: null,
        until: null,
      },
    };
  },
  computed: {
    label(): string {
      if (this.total === -1) return 'Unreviewed';
      return `Unreviewed (${this.total})`;
    },
  },
  methods: {
    load() {
      postRepository.count(this.filters).then((total) => {
        this.total = total;
      });
    },
    decrement() {
      this.total -= 1;
    },
    increment() {
      this.total += 1;
    },
    onPostMovedToTimeline(e: PostMovedToTimeline) {
      if (matches(e.post, this.filters)) this.decrement();
    },
    onPostTrashed(e: PostTrashed) {
      const post = Object.assign({}, e.post, { isTrashed: false });
      if (matches(post, this.filters)) this.decrement();
    },
    onPostRestored(e: PostRestored) {
      if (matches(e.post, this.filters)) this.increment();
    },
  },
  created() {
    eventBus.$on(PostSaved.eventName, this.decrement);
    eventBus.$on(PostEscalated.eventName, this.decrement);
    eventBus.$on(PostMovedToTimeline.eventName, this.onPostMovedToTimeline);
    eventBus.$on(PostTrashed.eventName, this.onPostTrashed);
    eventBus.$on(PostRestored.eventName, this.onPostRestored);
    this.load();
  },
  beforeUnmount() {
    eventBus.$off(PostSaved.eventName, this.decrement);
    eventBus.$off(PostEscalated.eventName, this.decrement);
    eventBus.$off(PostMovedToTimeline.eventName, this.onPostMovedToTimeline);
    eventBus.$off(PostTrashed.eventName, this.onPostTrashed);
    eventBus.$off(PostRestored.eventName, this.onPostRestored);
  },
});
</script>
